import { renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", {
    class: "tab",
    "data-is-active": _ctx.isActive,
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleClick(_ctx.name)))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 8, ["data-is-active"]))
}